// extracted by mini-css-extract-plugin
export default {"container":"ZgfTw","image":"LWHAA","title":"CGIuV","description":"quzcj","value":"gO0ks"};